import { type DirectusFiles } from '@funnellab/shared/src/types/directus.ts';
import fileService from '@src/api/services/FileService.ts';
import { useMemo } from 'react';

export type DirectusMediaProps = Pick<
  DirectusFiles,
  'id' | 'type' | 'filename_download'
> & {
  className?: string;
};

export default function DirectusMedia({
  id,
  type,
  filename_download,
  className,
}: DirectusMediaProps) {
  const data = useMemo(() => fileService.getFileDownloadUrl(id), [id]);

  if (type?.startsWith('video/')) {
    return (
      <video controls className={className} title={filename_download}>
        <source src={data} type={type} />
      </video>
    );
  } else {
    return (
      <img
        src={data}
        alt={filename_download}
        className={className}
        title={filename_download}
      />
    );
  }
}
